import { render } from "./MissionAndVisionSection.vue?vue&type=template&id=038c72b1&scoped=true"
import script from "./MissionAndVisionSection.vue?vue&type=script&lang=js"
export * from "./MissionAndVisionSection.vue?vue&type=script&lang=js"

import "./MissionAndVisionSection.vue?vue&type=style&index=0&id=038c72b1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038c72b1"]])

export default __exports__